module.exports = __webpack_public_path__ + "img/thumb-up.bc223998.png";